<template>
  <div class="container" style="margin-top: 10%;">
    <div class="row">
      <div class="col-md-12">
        <div v-if="activity.signIn" class="row">
          <div class="col-md-12">
            <sign-in v-bind:activity="activity" @show-loading="loadingStatus"></sign-in>
          </div>
        </div>
        <div v-if="activity.signUp" class="row">
          <div class="col-md-12">
            <sign-up v-bind:activity="activity"></sign-up>
          </div>
        </div>
        <div v-if="activity.changePsw" class="row">
          <div class="col-md-12">
            <change-psw v-bind:activity="activity"></change-psw>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import SignIn from './Login/SignIn';
  import SignUp from './Login/SignUp';
  import ChangePSW from './Login/ChangePsw';

    export default {
      components: {
        'sign-in':SignIn,
        'sign-up':SignUp,
        'change-psw':ChangePSW
      },
      data() {
        return {
          activity: {"signIn":true, "signUp":false,  "changePsw":false}
        }
      },
      methods:{
        loadingStatus(value){
          this.$emit('show-loading', value)
        }
      }
    }
</script>

<style scoped>

</style>
